import { base64ToBytes, readUInt32LE } from './utils.js';
const SYSTEM_INSTRUCTIONS = {
    0: 'CreateAccount',
    1: 'Assign',
    2: 'Transfer',
    3: 'CreateAccountWithSeed',
    4: 'AdvanceNonceAccount',
    5: 'WithdrawNonceAccount',
    6: 'InitializeNonceAccount',
    7: 'AuthorizeNonceAccount',
    8: 'Allocate',
    9: 'AllocateWithSeed',
    10: 'AssignWithSeed',
    11: 'TransferWithSeed',
    12: 'UpgradeNonceAccount',
};
export const decodeSystemInstruction = (ix) => {
    if (ix.programId !== '11111111111111111111111111111111')
        return undefined;
    if (!ix.data)
        return { name: 'System Instruction' };
    try {
        const buf = base64ToBytes(ix.data);
        const type = readUInt32LE(buf, 0);
        const name = SYSTEM_INSTRUCTIONS[type] ?? `Unknown (${type})`;
        return { name, args: { type } };
    }
    catch {
        return { name: 'System Instruction' };
    }
};
//# sourceMappingURL=system.js.map